(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[6],{

/***/ "/mE1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__qYcpy","version":"footer_version__1wg-W"};

/***/ }),

/***/ "2Vxx":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"popup":"cookiesPopup_popup__1w7Eu","popupText":"cookiesPopup_popupText__UQxcz","acceptButton":"cookiesPopup_acceptButton__2WXS5"};

/***/ }),

/***/ "A3V5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationList":"mainNavigation_navigationList__1OCw0","navigationItem":"mainNavigation_navigationItem__2z8Dz","label":"mainNavigation_label__1lj9S","icon":"mainNavigation_icon__1wFO8","link":"mainNavigation_link__2fakp"};

/***/ }),

/***/ "BsWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _unsupportedIterableToArray; });
/* harmony import */ var _babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a3WO");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(_babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_babel_runtime_helpers_esm_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(o, minLen);
}

/***/ }),

/***/ "ODXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _slicedToArray; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("BsWD");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ "Ruk8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__3nW0X","main":"layout_main__gDhVY"};

/***/ }),

/***/ "YFqc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cTJO")


/***/ }),

/***/ "Yucn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDidMount; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable react-hooks/exhaustive-deps */

var useDidMount = function useDidMount(cb) {
  return Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(cb, []);
};

/***/ }),

/***/ "Z4Yf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"headerSection":"mainHeader_headerSection__2nwR_","headerLink":"mainHeader_headerLink__auqks","title":"mainHeader_title__10znw"};

/***/ }),

/***/ "a3WO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayLikeToArray; });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "apO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Layout_Layout; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("9ixD");

// EXTERNAL MODULE: ./pages/_app.tsx + 1 modules
var _app = __webpack_require__("cha2");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__("suql");

// EXTERNAL MODULE: ./components/CookiesPopup/cookiesPopup.module.scss
var cookiesPopup_module = __webpack_require__("2Vxx");
var cookiesPopup_module_default = /*#__PURE__*/__webpack_require__.n(cookiesPopup_module);

// CONCATENATED MODULE: ./components/CookiesPopup/CookiesPopup.tsx





var CookiesPopup_CookiesPopup = function CookiesPopup() {
  var _useLocalStorage = Object(useLocalStorage["a" /* useLocalStorage */])('cookies-accepted', 'not-accepted'),
      _useLocalStorage2 = Object(slicedToArray["a" /* default */])(_useLocalStorage, 2),
      accepted = _useLocalStorage2[0],
      setAccepted = _useLocalStorage2[1];

  if (accepted === 'not-accepted') {
    return /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      className: cookiesPopup_module_default.a.popup,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
        className: cookiesPopup_module_default.a.popupText,
        children: "Ta strona, tak jak praktycznie ka\u017Cda w internecie, wykorzystuje ciasteczka."
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("button", {
        className: cookiesPopup_module_default.a.acceptButton,
        onClick: function onClick() {
          return setAccepted('accepted');
        },
        children: "Rozumiem"
      })]
    });
  }

  return null;
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./components/Footer/footer.module.scss
var footer_module = __webpack_require__("/mE1");
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);

// CONCATENATED MODULE: ./components/Footer/Footer.tsx




var date = new Date();
var copyrightYear = date.getFullYear();
var Footer_Footer = function Footer() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("footer", {
    className: footer_module_default.a.footer,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
      href: "https://vercel.com?utm_source=typeofweb&utm_campaign=oss",
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("img", {
          loading: "lazy",
          src: "/powered-by-vercel.svg",
          alt: "Powered by Vercel",
          width: 209,
          height: 40
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
      children: ["Copyright@", copyrightYear, " \u2013", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: "https://typeofweb.com",
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Type of Web"
        })
      }), ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
        "aria-hidden": true,
        className: footer_module_default.a.version,
        children: "preview_aloglia-front_8be92962f5173ba8bbbf230aad9b81e661f5ac73" || false
      })]
    })]
  });
};
Footer_Footer.displayName = 'Footer';
// EXTERNAL MODULE: ./components/MainHeader/mainHeader.module.scss
var mainHeader_module = __webpack_require__("Z4Yf");
var mainHeader_module_default = /*#__PURE__*/__webpack_require__.n(mainHeader_module);

// CONCATENATED MODULE: ./components/MainHeader/MainHeader.tsx




var MainHeader_MainHeader = function MainHeader() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])("section", {
    className: mainHeader_module_default.a.headerSection,
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
      href: "/",
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
        title: "Przejd\u017A na stron\u0119 g\u0142\xF3wn\u0105",
        className: mainHeader_module_default.a.headerLink,
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("h1", {
          className: mainHeader_module_default.a.title,
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            className: "sr-only",
            children: "Polski frontend"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("img", {
            src: "/logo.svg",
            alt: "",
            width: 480,
            height: 150
          })]
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./components/MainNavigation/mainNavigation.module.scss
var mainNavigation_module = __webpack_require__("A3V5");
var mainNavigation_module_default = /*#__PURE__*/__webpack_require__.n(mainNavigation_module);

// CONCATENATED MODULE: ./components/MainNavigation/MainNavigation.tsx




var links = [{
  href: '/o-serwisie',
  icon: 'question-circle',
  label: 'O serwisie',
  openInNewTab: false
}, {
  href: 'https://facebook.com/polskifrontend',
  icon: 'facebook',
  label: 'Facebook',
  openInNewTab: true
}, {
  href: "https://polskifrontend.pl/feed",
  icon: 'rss2',
  label: 'RSS',
  openInNewTab: true
}, {
  href: "https://discord.typeofweb.com",
  icon: 'discord',
  label: 'Discord',
  openInNewTab: true
}];
var MainNavigation_MainNavigation = function MainNavigation() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])("nav", {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])("ul", {
      className: mainNavigation_module_default.a.navigationList,
      children: links.map(function (_ref) {
        var label = _ref.label,
            href = _ref.href,
            openInNewTab = _ref.openInNewTab,
            icon = _ref.icon;
        return /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
          className: mainNavigation_module_default.a.navigationItem,
          children: openInNewTab ? /*#__PURE__*/Object(jsx_runtime["jsxs"])("a", {
            className: mainNavigation_module_default.a.link,
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            title: label,
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
              className: "icon-".concat(icon, " ").concat(mainNavigation_module_default.a.icon)
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
              className: mainNavigation_module_default.a.label,
              children: label
            })]
          }) : /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: href,
            children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("a", {
              className: mainNavigation_module_default.a.link,
              title: label,
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
                className: "icon-".concat(icon, " ").concat(mainNavigation_module_default.a.icon)
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
                className: mainNavigation_module_default.a.label,
                children: label
              })]
            })
          })
        }, href);
      })
    })
  });
};
// EXTERNAL MODULE: ./components/layout.module.scss
var layout_module = __webpack_require__("Ruk8");
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);

// CONCATENATED MODULE: ./components/Layout.tsx









var Layout_Layout = function Layout(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$titleTemplate = _ref.titleTemplate,
      titleTemplate = _ref$titleTemplate === void 0 ? _app["titleTemplate"] : _ref$titleTemplate;
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
    className: layout_module_default.a.wrapper,
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("header", {
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(MainNavigation_MainNavigation, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(MainHeader_MainHeader, {})]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("main", {
      className: layout_module_default.a.main,
      children: children
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Footer_Footer, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(CookiesPopup_CookiesPopup, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(next_seo_module["b" /* NextSeo */], {
      title: titleTemplate ? titleTemplate.replace('%s', title) : title,
      openGraph: {
        title: titleTemplate ? titleTemplate.replace('%s', title) : title
      }
    })]
  });
};

/***/ }),

/***/ "cTJO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireWildcard = __webpack_require__("284h");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _router = __webpack_require__("elyg");

var _router2 = __webpack_require__("nOHt");

var _useIntersection = __webpack_require__("vNVm");

var prefetched = {};

function prefetch(router, href, as, options) {
  if (false) {}
  if (!(0, _router.isLocalURL)(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options)["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || // triggers resource download
  event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
  var nodeName = e.currentTarget.nodeName;

  if (nodeName === 'A' && (isModifiedEvent(e) || !(0, _router.isLocalURL)(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault(); //  avoid scroll for urls with anchor refs

  if (scroll == null) {
    scroll = as.indexOf('#') < 0;
  } // replace state instead of push if prop is present


  router[replace ? 'replace' : 'push'](href, as, {
    shallow: shallow,
    locale: locale
  }).then(function (success) {
    if (!success) return;

    if (scroll) {
      window.scrollTo(0, 0);
      document.body.focus();
    }
  });
}

function Link(props) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var p = props.prefetch !== false;
  var router = (0, _router2.useRouter)();
  var pathname = router && router.pathname || '/';

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _ref = (0, _router.resolveHref)(pathname, props.href, true),
        _ref2 = _slicedToArray(_ref, 2),
        resolvedHref = _ref2[0],
        resolvedAs = _ref2[1];

    return {
      href: resolvedHref,
      as: props.as ? (0, _router.resolveHref)(pathname, props.as) : resolvedAs || resolvedHref
    };
  }, [pathname, props.href, props.as]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var children = props.children,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale; // Deprecated. Warning shown by propType check. If the children provided is a string (<Link>example</Link>) we wrap it in an <a> tag

  if (typeof children === 'string') {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  } // This will return the first child, if multiple are provided it will throw an error


  var child = _react.Children.only(children);

  var childRef = child && typeof child === 'object' && child.ref;

  var _ref3 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px'
  }),
      _ref4 = _slicedToArray(_ref3, 2),
      setIntersectionRef = _ref4[0],
      isVisible = _ref4[1];

  var setRef = _react["default"].useCallback(function (el) {
    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [childRef, setIntersectionRef]);

  (0, _react.useEffect)(function () {
    var shouldPrefetch = isVisible && p && (0, _router.isLocalURL)(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);
  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale);
      }
    }
  };

  childProps.onMouseEnter = function (e) {
    if (!(0, _router.isLocalURL)(href)) return;

    if (child.props && typeof child.props.onMouseEnter === 'function') {
      child.props.onMouseEnter(e);
    }

    prefetch(router, href, as, {
      priority: true
    });
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user


  if (props.passHref || child.type === 'a' && !('href' in child.props)) {
    childProps.href = (0, _router.addBasePath)((0, _router.addLocale)(as, typeof locale !== 'undefined' ? locale : router && router.locale, router && router.defaultLocale));
  }

  return /*#__PURE__*/_react["default"].cloneElement(child, childProps);
}

var _default = Link;
exports["default"] = _default;

/***/ }),

/***/ "suql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useLocalStorage; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useDidMount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Yucn");


function useLocalStorage(key, defaultValue) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(null),
      value = _useState[0],
      setValue = _useState[1];

  Object(_useDidMount__WEBPACK_IMPORTED_MODULE_1__[/* useDidMount */ "a"])(function () {
    try {
      var savedValue = localStorage.getItem(key);
      setValue(savedValue || defaultValue);
    } catch (_unused) {
      setValue(defaultValue);
    }
  });
  var setStoredValue = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (val) {
    setValue(val);

    try {
      localStorage.setItem(key, val);
    } catch (err) {
      console.error(err);
    }
  }, [key]);
  return [value, setStoredValue];
}

/***/ }),

/***/ "vNVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.useIntersection = useIntersection;

var _react = __webpack_require__("q1tI");

var _requestIdleCallback = _interopRequireDefault(__webpack_require__("0G5g"));

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react.useRef)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      visible = _ref3[0],
      setVisible = _ref3[1];

  var setRef = (0, _react.useCallback)(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, rootMargin, visible]);
  (0, _react.useEffect)(function () {
    if (!hasIntersectionObserver) {
      if (!visible) (0, _requestIdleCallback["default"])(function () {
        return setVisible(true);
      });
    }
  }, [visible]);
  return [setRef, visible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
    }
  };
}

var observers = new Map();

function createObserver(options) {
  var id = options.rootMargin || '';
  var instance = observers.get(id);

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

/***/ })

}]);